const navScripts = {
  init () {
    // add colour to background of off-canvas for nav menu
    $(".js-off-canvas-overlay").addClass('nav-active');

    // add/remove class based on scroll
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 5) {
            $(".c-site-header-container").addClass("scroll-enabled");

        } else {
            $(".c-site-header-container").removeClass("scroll-enabled");
        }
    });
    // if ($('.main-category-page')) {
    //   if (location.hash) {
    //     setTimeout(function() {
    //
    //       window.scrollTo(0, 0);
    //     }, 1);
    //   }
    // }


    }
  };

  export default navScripts;



// WEBPACK FOOTER //
// ./src/components/03-ui/00-site-header/00-site-header.js